import api, { ApiResponse } from './api';

import { Connection } from 'entities/Connection';

interface GetConnectionListResponse {
  success: boolean;
  data: Connection[];
}

export const getConnectionListService =
  (): ApiResponse<GetConnectionListResponse> =>
    api({
      method: 'GET',
      url: 'connections',
      useToken: true,
    });
